import type { ReactNode } from 'react';
import clsx from 'clsx';

export type ControlPlaneMetricTone = 'primary' | 'success' | 'warning' | 'danger' | 'info';

export interface ControlPlaneMetricItem {
  label: ReactNode;
  value: ReactNode;
  icon?: ReactNode;
  tone?: ControlPlaneMetricTone;
  description?: ReactNode;
}

export interface ControlPlaneMetricStripProps {
  items: ControlPlaneMetricItem[];
  className?: string;
}

export function ControlPlaneMetricStrip({ items, className }: ControlPlaneMetricStripProps) {
  if (items.length === 0) return null;

  return (
    <div className={clsx('vania-control-plane-metric-strip', className)}>
      {items.map((item, index) => (
        <div key={index} className={clsx('vania-control-plane-metric', item.tone && `vania-control-plane-metric--${item.tone}`)}>
          {item.icon ? <span className="vania-control-plane-metric__icon" aria-hidden="true">{item.icon}</span> : null}
          <span className="vania-control-plane-metric__label">{item.label}</span>
          <strong className="vania-control-plane-metric__value">{item.value}</strong>
          {item.description ? <span className="vania-control-plane-metric__description">{item.description}</span> : null}
        </div>
      ))}
    </div>
  );
}
